import api from './index';

export default {
  index() {
    return api({
      method: 'get',
      url: '/api/communes',
    });
  },
};
